import * as actionTypes from './actionTypes';

export const updateDeleteStatus = (status)=>({
    type:actionTypes.UPDATE_DELETE_STATUS,
    payload:status
})